module.exports = __webpack_public_path__ + "img/random.6f78683f.svg";